import api from "../../api";

export const createCredential = async (data) => {
  //create d payload for the request
  
  try {
    // Check if data contains a file in private_key
    if (data.private_key && data.private_key instanceof File) {
      // Create FormData for file upload
      const formData = new FormData();
      
      // Add all other data properties to formData
      Object.keys(data).forEach(key => {
        if (key === 'private_key') {
          formData.append('private_key', data.private_key);
        } else {
          formData.append(key, data[key]);
        }
      });
      
      // Send request with formData and appropriate headers
      const res = await api.post("/credential/create", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return res.data;

    } else {
      // Regular JSON request if no file is present
      const res = await api.post("/credential/create", data);
      return res.data;
      
    }
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};


export const deleteCredential = async (data) => {
  try {
    const res = await api.get("/credential/delete/"+data);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

